import { render, staticRenderFns } from "./live-casino.vue?vue&type=template&id=7bcc4335"
import script from "./live-casino.vue?vue&type=script&lang=js"
export * from "./live-casino.vue?vue&type=script&lang=js"
import style0 from "./live-casino.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/live-casino/live-casino.vue
// module id = ksMH
// module chunks = 0